import { TableHead, TableRow, TableHeaderText as HeaderText, TableHeader as Header } from '../StyledTable';
import { flexRender, HeaderGroup } from '@tanstack/react-table';
import { SortIcon } from './TableHeader.styles';

interface IProps<Data extends object> {
  isSortableTable?: boolean;
  getHeaderGroups: () => HeaderGroup<Data>[];
}

export const TableHeader = <Data extends object>(props: IProps<Data>) => {
  const { isSortableTable, getHeaderGroups } = props;
  return (
    <TableHead>
      {getHeaderGroups().map(headerGroup => (
        <TableRow key={headerGroup.id}>
          {headerGroup.headers.map(header => {
            const canSort = isSortableTable && header.column.getCanSort();
            return (
              <Header key={header.id}>
                {header.isPlaceholder ? null : (
                  <HeaderText
                    data-testid={canSort && 'sortable-column-header'}
                    $isSortable={canSort}
                    onClick={canSort ? header.column.getToggleSortingHandler() : undefined}
                  >
                    {flexRender(header.column.columnDef.header, header.getContext())}
                    {header.column.getIsSorted() && (
                      <SortIcon data-testid="sorting-icon" $isDescending={header.column.getIsSorted() === 'desc'} />
                    )}
                  </HeaderText>
                )}
              </Header>
            );
          })}
        </TableRow>
      ))}
    </TableHead>
  );
};
